<template>
  <transition name="modal">
    <div class="modal-mask">
      <div  class="modal-wrapper">
        <div class="modal-container p-0" :style="` ${maxWidth?`max-width:${maxWidth}px;`:''}`">

          <div >
            <a class="modal-default-button h1 pointer" @click="$emit('close')">
                X
              </a>
            <slot name="header">
              
            </slot>
          </div>

          <div class="modal-body ">
            <slot name="body">
          
            </slot>
          </div>

          <div >
            <slot name="footer">
              
              
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'Modal',
  props: [
    "maxWidth"
  ],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  position: relative;
  min-width: 300px;
  max-width: 50%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  border-radius: 16px 0px 0px 0px;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0px;
  padding: 0px 15px;
}

.modal-default-button {
  position: absolute;
  top:5px;
  right: 5px;
  z-index: 99;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
